import Vue from 'vue'

export default {
  listLFS({ companyIds, filters }) {
    return Vue.http.post(`app-services/v2/long-form-surveys/questions/list`, {
      filters: {
        companyIds,
        ...filters
      }
    })
  }
}
